import React from "react";

export const NotAuthenticated: React.FunctionComponent = () => {
  return <>Not NotAuthenticated</>;
};

export default NotAuthenticated;
